import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { FeriaGlobalFilters, FeriaGlobalListItem } from './types';

/**
 * Listagem global de Férias — `ApiEmployeeFeriasListAll`, publicado pela Genie
 * (card [6xpYsgzK]/ATD-0054, GATE_OK 2026-08-23; smoke verde). BFF roteia a
 * rota estática `GET /employees/ferias` em `registerEmployeeFeriasGlobal`.
 */
const BASE = '/v1/employees/ferias';

export const feriasGlobalApi = {
  async list(
    query: DataTableQuery,
    filters?: FeriaGlobalFilters,
  ): Promise<ListEnvelope<FeriaGlobalListItem>> {
    const { data } = await api.get<{
      data: Omit<FeriaGlobalListItem, 'id'>[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, {
      params: toGenexusParams(query, {
        colaboradorCodigo: filters?.colaboradorCodigo ?? undefined,
      }),
    });
    const normalized = normalizeListEnvelope(data);
    return {
      ...normalized,
      data: normalized.data.map((r) => ({ ...r, id: `${r.employeeId}-${r.dataInicio}` })),
    };
  },
};
